import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=554552e3&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"
import style0 from "./Heading.vue?vue&type=style&index=0&id=554552e3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554552e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554552e3')) {
      api.createRecord('554552e3', component.options)
    } else {
      api.reload('554552e3', component.options)
    }
    module.hot.accept("./Heading.vue?vue&type=template&id=554552e3&scoped=true", function () {
      api.rerender('554552e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/Heading.vue"
export default component.exports